import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { PlayCircleOutlined } from '@ant-design/icons';
import s from '../../s.module.less';

interface IStartNodeData {
    label?: string;
    type: 'start';
}

const StartNode: React.FC<NodeProps<IStartNodeData>> = ({ data, selected }) => {
    return (
        <div className={`${s.startNode} ${selected ? 'selected' : ''}`}>
            <Handle
                type="source"
                position={Position.Right}
                id="right"
                style={{ background: '#52c41a' }}
            />
            <div className={s.nodeContent}>
                <PlayCircleOutlined className={s.nodeIcon} />
                <div className={s.nodeLabel}>
                    {data.label || 'Start'}
                </div>
            </div>
        </div>
    );
};

export default StartNode;
